import * as React from 'react';
import cx from 'classnames';

import { AsideColumnLayout } from '../AsideColumnLayout/AsideColumnLayout';
import { AsideColumnLayoutSlot } from '../AsideColumnLayoutSlot/AsideColumnLayoutSlot';
import { HeaderLogo } from '../HeaderLogo/HeaderLogo';
import { ContactUsButton } from '../ContactUsButton/ContactUsButton';
import { Clickable } from '../../../../components/Clickable/Clickable';
import { MainNavigation } from '../MainNavigation/MainNavigation';
import { Show } from '../../../../components/Show/Show';
import { routes } from '../../../../config/routes';
import { Legal } from '../../../../components/Legal/Legal';
import { UpcomingEvent } from '../UpcomingEvent/UpcomingEvent';

import * as cs from './Header.module.css';

interface Props {
  themeMeta?: CustomTypes.ThemeMeta;
  forceUseTheme?: boolean;
  errorPage?: boolean;
  mainPage?: boolean;
  withBgImage?: boolean;
  isBgFullSize?: boolean | null;
  withPageBg?: boolean;
  showUpcomingEvent?: boolean;
}

export const Header = React.forwardRef(
  (
    {
      forceUseTheme,
      errorPage,
      mainPage,
      withBgImage,
      isBgFullSize,
      withPageBg,
      themeMeta,
      showUpcomingEvent,
    }: Props,
    ref: React.ForwardedRef<HTMLElement>,
  ) => {
    return (
      <header
        className={cx(cs.headerDesktop, {
          [cs.withBgImage]: withBgImage,
          [cs.withPageBg]: withPageBg,
          [cs.isBgFullSize]: isBgFullSize,
        })}
        ref={ref}
      >
        <AsideColumnLayout>
          <AsideColumnLayoutSlot
            position="top"
            forceUseTheme={forceUseTheme}
            desktopOnly
          >
            <div className={cs.links}>
              <Clickable
                className={cs.home}
                to={mainPage ? '#' : routes.home}
                aria-label="Home"
                trackEvent="primary-navigation-home"
              >
                <HeaderLogo />
              </Clickable>
              <Show when="sm">
                <ContactUsButton />
              </Show>
            </div>
          </AsideColumnLayoutSlot>
          <AsideColumnLayoutSlot
            position="center"
            forceUseTheme={forceUseTheme}
            hideOnTablet
          >
            <MainNavigation />
          </AsideColumnLayoutSlot>
          <AsideColumnLayoutSlot
            position="bottom"
            forceUseTheme={forceUseTheme}
            desktopOnly
          >
            {errorPage ? (
              <Legal />
            ) : (
              <UpcomingEvent
                show={showUpcomingEvent}
                whiteBg={themeMeta ? themeMeta.whiteBg : true}
              />
            )}
          </AsideColumnLayoutSlot>
        </AsideColumnLayout>
      </header>
    );
  },
);

Header.displayName = 'Header';
